<template>

  <v-container fluid class="px-0 mt-0 page page-receiver-license-history">

    <!-- Breadcrumb & Actions -->
    <v-row class="mt-3 mb-5">
      <v-col cols="12" class="d-flex align-center justify-start page-breadcrumb-new">
        <!-- (breadcrumb) -->
        <v-icon small class="mr-2">mdi-store</v-icon>
        <router-link :to="{ name: (uiType === 'shipper' || uiType === 'sys-admin') ? 'receiver-list' : 'receiver-ui-receiver-location-list' }">
          Receiver Locations
        </router-link>
        <div class="separator">/</div>
        <div class="active-item">License Change History</div>
      </v-col>
    </v-row>

    <!-- Change History List -->
    <location-license-change-list-data-table
        locationType="receiver"
        :showDismiss="uiType === 'shipper'" />

  </v-container>

</template>

<script>
import LocationLicenseChangeListDataTable from '@/components/locations/LocationLicenseChangeListDataTable'

export default {
  name: 'ReceiverLicenseChangeHistoryPage',

  components: {
    LocationLicenseChangeListDataTable
  },

  computed: {
    uiType () {
      return this.$root.uiType() || 'unknown'
    }
  }
}
</script>

<style scoped>
</style>
